export default function oldMobileList(){
    return(
        [
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS002",
                    "brand": "iPhone",
                    "seNo": "000",
                    "model": "iPhone 8 64GB Space Gray",
                    "description": "iPhone 8 64GB Space Gray",
                    "purchaseDate": "2019-09-18",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2020-09-17",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Rajendran Ayyappan",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2019-09-18",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2019-09-18",
                        "returnDate": "2019-09-18",
                    },
                    {
                        "user": "Rajendran Ayyappan",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2019-09-18",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS003",
                    "brand": "iPhone",
                    "seNo": "000",
                    "model": "iPhone 8 64GB Space Gray",
                    "description": "iPhone 8 64GB Space Gray",
                    "purchaseDate": "2019-09-18",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2020-09-17",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Lim Yee Ling",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2019-09-18",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2019-09-18",
                        "returnDate": "2019-09-18",
                    },
                    {
                        "user": "Lim Yee Ling",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2019-09-18",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS005",
                    "brand": "iPhone",
                    "seNo": "000",
                    "model": "iPhone 8 64GB Space Gray",
                    "description": "iPhone 8 64GB Space Gray",
                    "purchaseDate": "2019-09-18",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2020-09-17",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Dhamelia Urja Anand",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2019-09-18",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2019-09-18",
                        "returnDate": "2019-09-18",
                    },
                    {
                        "user": "Dhamelia Urja Anand",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2019-09-18",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS005",
                    "brand": "iPhone",
                    "seNo": "000",
                    "model": "iPhone 8 64GB Space Gray",
                    "description": "iPhone 8 64GB Space Gray",
                    "purchaseDate": "2019-09-18",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2020-09-17",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "HQ",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2024-01-04",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2019-09-18",
                        "returnDate": "2019-09-18",
                    },
                    {
                        "user": "Serrano Ferdinand Arzobal",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2019-09-18",
                        "returnDate": "2024-01-04",
                    },
                    {
                        "user": "HQ",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2024-01-04",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS006",
                    "brand": "iPhone",
                    "seNo": "000",
                    "model": "iPhone 8 64GB Space Gray",
                    "description": "iPhone 8 64GB Space Gray",
                    "purchaseDate": "2019-09-18",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2020-09-17",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Arumugam Azhakar",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2019-09-18",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2019-09-18",
                        "returnDate": "2019-09-18",
                    },
                    {
                        "user": "Arumugam Azhakar",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2019-09-18",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS007",
                    "brand": "iPhone",
                    "seNo": "000",
                    "model": "iPhone 8 64GB Space Gray",
                    "description": "iPhone 8 64GB Space Gray",
                    "purchaseDate": "2019-09-18",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2020-09-17",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Uddin Mayen",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2019-09-18",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2019-09-18",
                        "returnDate": "2019-09-18",
                    },
                    {
                        "user": "Uddin Mayen",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2019-09-18",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS008",
                    "brand": "iPhone",
                    "seNo": "000",
                    "model": "iPhone 8 64GB Space Gray",
                    "description": "iPhone 8 64GB Space Gray",
                    "purchaseDate": "2019-09-18",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2020-09-17",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Hossin Delwer",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2019-09-18",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2019-09-18",
                        "returnDate": "2019-09-18",
                    },
                    {
                        "user": "Hossin Delwer",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2019-09-18",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS009",
                    "brand": "iPhone",
                    "seNo": "000",
                    "model": "iPhone XR 256GB Black",
                    "description": "iPhone XR 256GB Black",
                    "purchaseDate": "2020-01-07",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2021-01-07",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Govindarajulu Vijay",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2020-01-07",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2020-01-07",
                        "returnDate": "2020-01-07",
                    },
                    {
                        "user": "Govindarajulu Vijay",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2020-01-07",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS010",
                    "brand": "iPhone",
                    "seNo": "C39QF4VCGRWY",
                    "model": "iPhone 6S Plus 64GB White",
                    "description": "iPhone 6S Plus 64GB White, Phone no 83211875",
                    "purchaseDate": "2018-08-18",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2019-08-18",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "HQ",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2018-08-18",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2018-08-18",
                        "returnDate": "2018-08-18",
                    },
                    {
                        "user": "HQ",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2019-09-18",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS011",
                    "brand": "iPhone",
                    "seNo": "000",
                    "model": "iPhone 6 128GB Space Gray",
                    "description": "iPhone 6 128GB Space Gray",
                    "purchaseDate": "2020-01-01",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2021-01-01",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Ahmed Shibbir",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2020-01-01",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2020-01-01",
                        "returnDate": "2020-01-01",
                    },
                    {
                        "user": "Ahmed Shibbir",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2019-09-18",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS012",
                    "brand": "iPhone",
                    "seNo": "FFMH70KAPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2020-09-17",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Dipok Dilip",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Dipok Dilip",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS013",
                    "brand": "iPhone",
                    "seNo": "FFMGQ47APLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-05-24",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Hasan Kamrul",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-05-24",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-05-24",
                        "returnDate": "2022-05-24",
                    },
                    {
                        "user": "Hasan Kamrul",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-05-24",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS014",
                    "brand": "iPhone",
                    "seNo": "FFMGQ4BNPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-05-24",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Rajendran Ayyappan",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-05-24",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-05-24",
                        "returnDate": "2022-05-24",
                    },
                    {
                        "user": "Rajendran Ayyappan",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-05-24",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS015",
                    "brand": "iPhone",
                    "seNo": "FFKGQ43HPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Das Nirmol",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Das Nirmol",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS016",
                    "brand": "iPhone",
                    "seNo": "FFMGQ483PLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Panvarthudan Ashokkumar",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Panvarthudan Ashokkumar",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS017",
                    "brand": "iPhone",
                    "seNo": "000",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-05-25",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-05-25",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Teo Teng Cheow",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-05-25",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-05-25",
                        "returnDate": "2022-05-25",
                    },
                    {
                        "user": "Teo Teng Cheow",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-05-25",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS018",
                    "brand": "iPhone",
                    "seNo": "FFMGQ44EPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Lim Yee Ling",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Lim Yee Ling",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS019",
                    "brand": "iPhone",
                    "seNo": "FMGQ4DKPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Vinayagamoorthy Ajithkumar",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Vinayagamoorthy Ajithkumar",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS020",
                    "brand": "iPhone",
                    "seNo": "FMGQ4DKPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Madhavan Rajarajan",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Madhavan Rajarajan",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS021",
                    "brand": "iPhone",
                    "seNo": "FFMGQ42DPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Myat Noe Aung",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Myat Noe Aung",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS022",
                    "brand": "iPhone",
                    "seNo": "FFMGQ4APPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Chowdhury Md Abdul Aziz",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Chowdhury Md Abdul Aziz",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS023",
                    "brand": "iPhone",
                    "seNo": "FFMGN566PLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Thennarasu Thenishkumar",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Thennarasu Thenishkumar",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS024",
                    "brand": "iPhone",
                    "seNo": "FFMGN7HAOLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS Includes: 1x power plug adaptor 1x tempered glass 1x clear case 1x cable SIM",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Edwin Wu Hong Yi",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Edwin Wu Hong Yi",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS025",
                    "brand": "iPhone",
                    "seNo": "000",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Rubel Mohammad",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Rubel Mohammad",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS026",
                    "brand": "iPhone",
                    "seNo": "000",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Molla Ziaul",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Molla Ziaul",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS027",
                    "brand": "iPhone",
                    "seNo": "FFMGN4j3PLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Khalil Mohammed Ibrahim",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Khalil Mohammed Ibrahim",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS028",
                    "brand": "iPhone",
                    "seNo": "FFMGN6V2PLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Sangaya Murugesan",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Sangaya Murugesan",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS029",
                    "brand": "iPhone",
                    "seNo": "FFMG6KPPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Abedin Joynal",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Abedin Joynal",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS030",
                    "brand": "iPhone",
                    "seNo": "FFMGN7R8PLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Ramalingam Vignesh",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Ramalingam Vignesh",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS031",
                    "brand": "iPhone",
                    "seNo": "FFMGN7T0PLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS Includes: -1 x charger -1 x cable -1 x sim card ONE 4123 -1 x UGS casing",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Islam Md Samiul",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Islam Md Samiul",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS032",
                    "brand": "iPhone",
                    "seNo": "FFMGN6TNPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Uddin Mohammad Wahid",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Uddin Mohammad Wahid",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS033",
                    "brand": "iPhone",
                    "seNo": "FFMGV2G5PLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Ramasamy Chelladurai",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Ramasamy Chelladurai",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS034",
                    "brand": "iPhone",
                    "seNo": "FFMGV2JFPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Quek Poh Teng",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Quek Poh Teng",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS035",
                    "brand": "iPhone",
                    "seNo": "FFMGV5EKPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Uddin Md Shihab",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Uddin Md Shihab",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS037",
                    "brand": "iPhone",
                    "seNo": "FFMGN84EPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Mohammad Aslam",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Mohammad Aslam",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS038",
                    "brand": "iPhone",
                    "seNo": "FFMGN90DPLK2",
                    "model": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "description": "iPhone 8 64GB Space Gray",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Ahmed Riaj",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Ahmed Riaj",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS039",
                    "brand": "iPhone",
                    "seNo": "FFMGN6BGPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Uddin Najim",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Uddin Najim",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS040",
                    "brand": "iPhone",
                    "seNo": "FFMGN7L0PLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Atiquzzaman",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Atiquzzaman",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS041",
                    "brand": "iPhone",
                    "seNo": "FFMGN780PLS2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Omit Syed Hasanuzzaman",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Omit Syed Hasanuzzaman",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS042",
                    "brand": "iPhone",
                    "seNo": "FFMGN6V2PLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Roni Jahidur Rahman",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Roni Jahidur Rahman",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS043",
                    "brand": "iPhone",
                    "seNo": "FFMGN7WWAPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Valluru Ashok Kumarreddy",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Valluru Ashok Kumarreddy",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS044",
                    "brand": "iPhone",
                    "seNo": "FFMG51HPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Shanta Md",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Shanta Md",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS045",
                    "brand": "iPhone",
                    "seNo": "FFMGN8WDPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2022-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "HQ",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "HQ",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS046",
                    "brand": "iPhone",
                    "seNo": "FFMGN67YPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Hussain Akmal",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Hussain Akmal",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS036",
                    "brand": "iPhone",
                    "seNo": "FFMGV53WPLK2",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "HQ",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "HQ",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS047",
                    "brand": "iPhone",
                    "seNo": "RR2C0WT9H7",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Kabir Humayun",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Kabir Humayun",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS052",
                    "brand": "iPhone",
                    "seNo": "GJG7XWTCFW",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "XO PLUS 50 (with 10GB Local Data) 100 Mins 100 SMS",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Uddin Mohammad Wahid",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Uddin Mohammad Wahid",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS048",
                    "brand": "iPhone",
                    "seNo": "QRXCLJP25V",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "Box includesCOLON Unit, Power plug Adaptor, Tempered Glass, Clear Case and Cable.",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Miah Sumon",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Miah Sumon",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS049",
                    "brand": "iPhone",
                    "seNo": "CF125G44HD",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "Box includesCOLON Unit, Power plug Adaptor, Tempered Glass, Clear Case and Cable.",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Dhaveethu Bai Edbin George",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Dhaveethu Bai Edbin George",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS050",
                    "brand": "iPhone",
                    "seNo": "QCQ7272MYQ",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "Box includesCOLON Unit, Power plug Adaptor, Tempered Glass, Clear Case and Cable.",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Baskar Manojkumar",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Baskar Manojkumar",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS051",
                    "brand": "iPhone",
                    "seNo": "QCQ7272MYQ",
                    "model": "iPhone SE 2nd edition 128GB Black",
                    "description": "Box includesCOLON Unit, Power plug Adaptor, Tempered Glass, Clear Case and Cable.",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Veeramani Sarathkumar",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2022-03-30",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Veeramani Sarathkumar",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2022-03-30",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "Mobile Phone",
                "subCat": "iPhone",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-IPS053",
                    "brand": "iPhone",
                    "seNo": "DNPNX4P9G5ML",
                    "model": "iPhone 6 128GB Space Gray",
                    "description": "Serial NumberCOLON DNPNX4P9G5ML NEWLINESIM planCOLON Singtel SIM only 30 plan - 88768178 NEWLINENo charging set attach, changed for new cover and screen protector",
                    "purchaseDate": "2022-03-30",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2023-03-30",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Ye Zhijiang",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2024-01-25",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2022-03-30",
                        "returnDate": "2022-03-30",
                    },
                    {
                        "user": "Ye Zhijiang",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2024-01-25",
                        "returnDate": "",
                    }
                ])
            },//////////////////tms
            {
                "cat": "TMS",
                "subCat": "Xiaomi",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-TMS015",
                    "brand": "Xiaomi",
                    "seNo": "26320/00QQ00501",
                    "model": "RedMi 8A",
                    "description": "Midnight Black",
                    "purchaseDate": "2020-08-01",
                    "purchaseValue": "150",
                    "warrantyDueDate": "2021-08-01",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Mery Juana",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2020-08-01",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2020-08-01",
                        "returnDate": "2020-08-01",
                    },
                    {
                        "user": "Mery Juana",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2020-08-01",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "TMS",
                "subCat": "Fingerprint Scanner",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-TMS019",
                    "brand": "Whyze",
                    "seNo": "6246151600004",
                    "model": "Fingerprint Scanner",
                    "description": "",
                    "purchaseDate": "2023-05-26",
                    "purchaseValue": "165",
                    "warrantyDueDate": "2024-05-26",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Nur Muhammad Matien Bin Kamarudin",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2023-05-26",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-05-26",
                        "returnDate": "2023-05-26",
                    },
                    {
                        "user": "Nur Muhammad Matien Bin Kamarudin",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2023-05-26",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "TMS",
                "subCat": "Fingerprint Scanner",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-TMS021",
                    "brand": "Whyze",
                    "seNo": "CDQ922156003",
                    "model": "Fingerprint Scanner",
                    "description": "Midnight Black",
                    "purchaseDate": "2023-06-26",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2024-06-26",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Myat Noe Aung",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2023-06-26",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-06-26",
                        "returnDate": "2023-06-26",
                    },
                    {
                        "user": "Myat Noe Aung",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2023-06-26",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "TMS",
                "subCat": "Fingerprint Scanner",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-TMS020",
                    "brand": "Whyze",
                    "seNo": "CDQ9231260007",
                    "model": "Fingerprint Scanner",
                    "description": "",
                    "purchaseDate": "2023-05-26",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2024-05-26",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Govindarajulu Vijay",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2023-05-26",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-05-26",
                        "returnDate": "2023-05-26",
                    },
                    {
                        "user": "Govindarajulu Vijay",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2023-05-26",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "TMS",
                "subCat": "Fingerprint Scanner",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-TMS001",
                    "brand": "Whyze",
                    "seNo": "000",
                    "model": "Fingerprint Scanner",
                    "description": "",
                    "purchaseDate": "2016-06-02",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2017-06-02",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Mery Juana",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2016-06-02",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2016-06-02",
                        "returnDate": "2016-06-02",
                    },
                    {
                        "user": "Mery Juana",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2016-06-02",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "TMS",
                "subCat": "Fingerprint Scanner",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-TMS004",
                    "brand": "Whyze",
                    "seNo": "000",
                    "model": "Fingerprint Scanner",
                    "description": "",
                    "purchaseDate": "2016-06-02",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2017-06-02",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Dhamelia Urja Anand",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2016-06-02",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2016-06-02",
                        "returnDate": "2016-06-02",
                    },
                    {
                        "user": "Dhamelia Urja Anand",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2016-06-02",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "TMS",
                "subCat": "Fingerprint Scanner",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-TMS005",
                    "brand": "Whyze",
                    "seNo": "000",
                    "model": "Fingerprint Scanner",
                    "description": "",
                    "purchaseDate": "2016-06-02",
                    "purchaseValue": "0",
                    "warrantyDueDate": "2017-06-02",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Myat Noe Aung",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2016-06-02",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2016-06-02",
                        "returnDate": "2016-06-02",
                    },
                    {
                        "user": "Myat Noe Aung",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2016-06-02",
                        "returnDate": "",
                    }
                ])
            },
            {
                "cat": "TMS",
                "subCat": "Fingerprint Scanner",
                "itemDetail": JSON.stringify({
                    "equipmentNo": "GLEC-TMS022",
                    "brand": "Whyze",
                    "seNo": "CDQ9231260009",
                    "model": "Fingerprint Scanner",
                    "description": "",
                    "purchaseDate": "2023-11-10",
                    "purchaseValue": "1124",
                    "warrantyDueDate": "2024-11-10",
                }),
                "issueDetail": JSON.stringify({
                    "receiver": "Rajendran Ayyappan",
                    "issuer": "Lim Sock Peng",
                    "issueDate": "2023-11-10",
                }),
                "historyUser": JSON.stringify([
                    {
                        "user": "HQ",
                        "issuer": "HQ",
                        "issueDate": "2023-11-10",
                        "returnDate": "2023-11-10",
                    },
                    {
                        "user": "Rajendran Ayyappan",
                        "issuer": "Lim Sock Peng",
                        "issueDate": "2023-11-10",
                        "returnDate": "",
                    }
                ])
            },
            
        ]
    )
}